module.exports = __webpack_public_path__ + "img/factions-movie.0e2d547b.jpg";